export default __webpack_public_path__ + "static/media/BoardHanger.fa1c14bd.svg";